export const PreventiveMaintenanceIntervalUnit = {
  DAY: 'DAY',
  WEEK: 'WEEK',
  MONTH: 'MONTH',
  YEAR: 'YEAR',
  SESSION: 'SESSION',
  KWH: 'KWH',
  HOUR: 'HOUR',
} as const;

export type PreventiveMaintenanceIntervalUnit =
  (typeof PreventiveMaintenanceIntervalUnit)[keyof typeof PreventiveMaintenanceIntervalUnit];
